const NAME = '[a-z_][a-z0-9_]*'
const OUTPUT = new RegExp(`^\\{\\{\\s*(${NAME})(?:\\s*\\|\\s*default\\('(?:[^'\\\\]|\\\\.)*'\\s*,\\s*true\\))?\\s*\\}\\}$`)
const OPERAND = `(?:${NAME}|'[^'\\\\]*')`
const BARE_TERM = `${NAME}(?:\\s+is\\s+defined|\\s*\\|\\s*default\\(''\\)|\\s*(?:!=|==)\\s*${OPERAND})?`
const TERM = `(?:\\(${BARE_TERM}\\)|${BARE_TERM})`
const IF = new RegExp(`^\\{%-?\\s*if\\s+(${TERM}(?:\\s+and\\s+${TERM})*)\\s*-?%\\}$`)
const ELSE_OR_END = /^\{%-?\s*(else|endif)\s*-?%\}$/
const TAGS = /\{\{\{|\}\}\}|\{\{[\s\S]*?\}\}|\{%[\s\S]*?%\}|\{#[\s\S]*?#\}/g
const NAMES_IN = new RegExp(NAME, 'g')
const KEYWORDS = new Set(['is', 'defined', 'and', 'default'])
const LITERALS = /'[^']*'/g
const OPENERS = /\{\{|\{%|\{#/

export const checkJinja = (text: string, variableNames: string[]): string[] => {
  const known = new Set(variableNames)
  const unfinished = OPENERS.exec(text.replace(TAGS, ''))
  const tagProblems = Array.from(text.matchAll(TAGS)).flatMap(([tag]) => {
    const output = OUTPUT.exec(tag)
    if (output) {
      return known.has(output[1]) ? [] : [`Unknown variable in ${tag}`]
    }
    if (ELSE_OR_END.test(tag)) {
      return []
    }
    const condition = IF.exec(tag)
    if (condition) {
      const unknown = Array.from(condition[1].replace(LITERALS, '').matchAll(NAMES_IN))
        .map((match) => match[0])
        .filter((name) => !KEYWORDS.has(name) && !known.has(name))
      return unknown.length ? [`Unknown variable in ${tag}`] : []
    }
    return [`Template logic isn't allowed: ${tag}`]
  })
  return unfinished ? [...tagProblems, `Unfinished template tag: ${unfinished[0]}`] : tagProblems
}

export const validateCompiled = (subject: string, body: string, variableNames: string[]): string[] => [
  ...checkJinja(subject, variableNames),
  ...checkJinja(body, variableNames),
]
